import React, { useContext, useEffect, useRef, useState } from 'react'
import VideocamOffIcon from '@mui/icons-material/VideocamOff';
import axios from 'axios';
import { baseUrl, path } from '../../../constants';
import { Oval } from 'react-loader-spinner';
import CancelIcon from '@mui/icons-material/Cancel';
import FileIcon from '@mui/icons-material/FileCopy';
import { useQuery } from 'react-query';
import { api } from '../../../api';
import { settingsContext } from '../../../Context/settingsProvider';

export default function Materials({ sectionId, setSelected }) {
    const { isLoading, error, data, refetch } = useQuery('fetchMaterials', () =>
        api(baseUrl + path.getSectionMaterials + '/' + sectionId, {})
    )
    const {t} = useContext(settingsContext)
    // const config = {
    //     onUploadProgress: progressEvent => console.log(progressEvent.loaded)
    // }

    

  return (
    <div className='fixed inset-0 bg-[#00000070] flex items-center justify-center z-[999999]'>
        <div className='flex flex-col bg-white w-[70%] max-md:w-[90%] h-[80%] relative rounded-md gap-5'>

           <div className='flex flex- flex-col'>
            <table className='border-[1px] border-[#00000050] border-collapse w-full' style={{
                padding: 10
            }}>
                <thead>
                    <tr className='bg-[#e2e2e280]'>
                        <th align='left' className='p-2 max-md:text-[12px]'>{t('FILE_NAME')}</th>
                        <th align='left' className='p-2 max-md:text-[12px]'>{t('TYPE')}</th>
                        <th align='left' className='p-2 max-md:text-[12px]'>{t('SIZE')}</th>
                        <th align='left' className='p-2 max-md:text-[12px]'>{t('DOWNLOAD_LINK')}</th>
                    </tr>
                </thead>
          
                    <tbody>
                        {data?.data?.materials?.map(material => (
                            <tr>
                                <td className='p-2 text-[14px] text-black'>{material.name}</td>
                                <td className='p-2 text-[14px] text-black'>{material.type?.toUpperCase()}</td>
                                <td className='p-2 text-[14px] text-black'>{(material.size / (1024 * 1024)).toFixed(2)} MB</td>
                                <td className='p-2 text-[14px] text-[#3161b5]'><a href={baseUrl + material.path} rel='noreferrer' target='_blank'>{t('OPEN')}</a></td>
                            </tr>
                        ))}
                    </tbody>
                
            </table>
            {isLoading && (
                        <div className='flex flex-col gap-3 flex-1 items-center p-5 justify-center'>
                            <p className='text-[16px]'>Loading section materials...</p>
                            <Oval
                                visible={true}
                                height="30"
                                width="30"
                                color="#198754"
                                ariaLabel="oval-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                                strokeWidth={3}
                            />
                        </div>
                ) }
           </div>
             <button onClick={() => setSelected(null)} className='absolute outline-none bg-white rounded-full bg-none -top-4 -right-4 flex items-center justify-center'>
                <CancelIcon style={{fontSize: 25, color: '#000000'}}>Filled</CancelIcon>
             </button>
        </div>
    </div>
  )
}
